<template>
  <v-form ref="form">
    <v-container grid-list-md>
      <v-layout v-if="!ui.loading">
        <v-flex xs12>
          <v-toolbar color="pink" dark>
            <v-icon>loupe</v-icon>
            <v-toolbar-title>Team Details</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field v-model="club.name" :rules="ui.required" label="Team Name"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="club.location"
                    :rules="ui.required"
                    label="Team's Location"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="club.identity.username"
                    :rules="ui.required"
                    label="Team's Username"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="club.identity.password"
                    type="password"
                    :rules="ui.passwordRules"
                    label="Team's Password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red lighten-1" dark @click="cancel">Cancel</v-btn>
              <v-btn color="primary" :loading="ui.isBusy" @click="save">{{club.id?"Update":"Register"}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-if="ui.loading">
        <v-flex>
          <v-card>
            <div class="text-xs-center pa-3">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="ui.snackbar" :color="ui.snackbarMode" :timeout="5000">
      <span>{{ ui.feedback }}</span>
      <v-btn dark flat @click="ui.snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-form>
</template>

<script>

export default {
  data: function() {
    return {
      club: {
        id: "",
        name: "",
        location: "",
        identity: {
          username: "",
          password: ""
        }
      },
      ui: {
        required: [
          function(x) {
            return x ? true : "This field is required";
          }
        ],
        passwordRules:[],
        snackbar: false,
        feedback: "",
        snackbarMode: "success",
        showConfirm: false,
        isDirty: false,
        loading:false,
        isBusy:false
      }
    };
  },
  methods: {
    save: function() {
      if (!this.$refs.form.validate()) return;

      var me = this;
      var endpoint = this.$api("clubs");
      me.ui.isBusy=true;
      var task = this.club.id
        ? endpoint.put(this.club)
        : endpoint.post(this.club);
      task
        .then(function() {
          me.showsnackBar("Saved successfully!", "success");
          me.$router.push({name:"club-list"});
        })
        .catch(function(ex) {
          var msg =
            ex && ex.responseJSON
              ? ex.responseJSON.feedback || ex.responseJSON.title
              : "An error occured!";
          me.showsnackBar(msg, "error");
        }).finally(function(){
          me.ui.isBusy=false;
        });
    },
    showsnackBar: function(msg, mode) {
      this.ui.feedback = msg;
      this.ui.snackbar = true;
      this.ui.snackbarMode = mode || "info";
    },
    load: function(id) {
      var me = this;
      me.ui.loading=true;
      this.$api("clubs")
        .get({ id: id })
        .then(function(resp) {
          me.club = resp;
          me.ui.passwordRules=[];
          me.ui.isDirty=false;
        })
        .catch(function(ex) {
          var msg =
            ex && ex.responseJSON
              ? ex.responseJSON.feedback || ex.responseJSON.title
              : "An error occured!";
          me.showsnackBar(msg, "error");
        }).finally(function(){
           me.ui.loading=false;
        });
    },
    cancel: function() {
        if(this.ui.isDirty)
            this.ui.showConfirm = true;
        else
            this.showClubList();
    },
    showClubList:function(){
        this.$router.push({name:"club-list"});
    }
  },
  mounted: function() {
      this.ui.passwordRules=this.ui.required;
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
  beforeRouteUpdate: function(to, from, next) {
    if (to.params.id) this.load(to.params.id);
    next();
  }
};
</script>

<style>
</style>
